import { AboutYou, defaultAboutYou } from "domain/aboutYou";
import { action, makeObservable } from "mobx";
import { StoreBase } from "./storeBase";

export class AboutYouStore extends StoreBase<{}> {
  constructor() {
    super(() => defaultAboutYou());
    makeObservable(this);
  }

  data: AboutYou = defaultAboutYou();

  @action storeAboutYou(aboutYou: AboutYou) {
    this.data = aboutYou;
  }
}
